import React from 'react';
import ListItemBase from './ListItemBase';

import TListItemBasicProps from './@types/TListItemBasicProps';

const ListItemBasic = ({ children, ...rest }: TListItemBasicProps) => (
  <ListItemBase {...rest} as="li">
    {children}
  </ListItemBase>
);

export default ListItemBasic;
